import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonAccordionGroup, IonAccordion, IonItem, IonLabel, ModalController } from '@ionic/angular/standalone';
import { Field } from '../../models/Field';
import { FieldInputType } from "@qid/core";
import { SexyModule } from "@qid/sexy";
import { SuperButtonComponent, SuperInputComponent } from "@qid/super";


@Component({
  selector: 'create-field',
  templateUrl: './create-field.component.html',
  styleUrls: ['./create-field.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonAccordionGroup,
    IonAccordion,
    IonItem,
    IonLabel,
    SexyModule,
    SuperButtonComponent,
    SuperInputComponent
  ]
})
export class CreateFieldComponent implements OnInit {


  @Input() action: (value: any) => {} = null;

  @Input() field: Field = new Field()

  inputTypes = Object.values(FieldInputType)
  @Input() selectedType = 'text';

  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
    // setTimeout(() => {
    //   if (this.input) {
    //     this.input.setFocus();
    //   }
    // }, 100);
  }

  ionViewDidEnter() {
  }

  close(data = null) {
    this.modalController.dismiss({
      field: data,
    });
  }

  onSubmit = async () => {
    this.close(this.field)
  };


}
